import _isFinite from 'lodash/isFinite';
import { ArrayUtilities } from '@pwc/pwc-deals-web-common';

import {
  viewDebtAndDebtLikePath,
  viewNetWorkingCapitalPath,
  viewQualityOfEarningsPath,
} from '../../services/urlService';

const textIsYesRegEx = /^yes$/i;

export const QUALITY_OF_EARNINGS_SUB_TYPE = 200;
export const NET_WORKING_CAPITAL_SUB_TYPE = 300;
export const DEBT_AND_DEBT_LIKE_SUB_TYPE = 400;

export const createMetadataFromRaw = (
  metadata,
  startColumnIndex,
  rawValues,
  rawDataHeaderRowIndex = -1
) => {
  const extractedMetadata = {};

  const indexOf2dArrayOptions =
    rawDataHeaderRowIndex >= 0
      ? {
          stopBeforeRowIndex: rawDataHeaderRowIndex,
        }
      : undefined;

  Object.keys(metadata || {}).forEach((k) => {
    const metadataPosition = ArrayUtilities.indexOf2dArray(
      rawValues,
      metadata[k],
      indexOf2dArrayOptions
    );

    if (metadataPosition) {
      const metadataRow = rawValues[metadataPosition[0]];
      const metadataRowActiveColumns = metadataRow.slice(startColumnIndex, -1);
      const metadataRowAsBooleans = metadataRowActiveColumns.map((c) =>
        textIsYesRegEx.test(c)
      );
      extractedMetadata[k] = metadataRowAsBooleans;
    }
  });

  return extractedMetadata;
};

export const sanitizeSummableValue = (text) => {
  try {
    const floatValue = parseFloat(text);
    return _isFinite(floatValue) ? floatValue : 0;
  } catch (_) {
    return 0;
  }
};

export const structuredAnalysisLinkToDisplay = (
  projectId,
  displayName,
  subType
) => {
  if (subType === QUALITY_OF_EARNINGS_SUB_TYPE) {
    return viewQualityOfEarningsPath(projectId);
  }
  if (subType === NET_WORKING_CAPITAL_SUB_TYPE) {
    return viewNetWorkingCapitalPath(projectId);
  }
  if (subType === DEBT_AND_DEBT_LIKE_SUB_TYPE) {
    return viewDebtAndDebtLikePath(projectId);
  }
  return displayName;
};
